import React from 'react'
import './FaultFirstPageCustom_Coral.css';
import { useEffect, useState } from 'react';
import "./Horizantal_Coral.css"
import * as $ from 'jquery';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import { Link, Navigate } from "react-router-dom";
import Table_Coral from './Table_Coral';
import NoTableData_Coral from '../../../../componets/Dashboard_Coral/Driveanalysis_Coral/NoTableData_Coral';
import ChartLoader_Coral from '../../Driveanalysis_Coral/ChartLoader_Coral';
import WaterMark from '../../DashboardMain_Coral/WaterMark';

function FaultFirstPageDataBars_Coral(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const [tableData, setTableData] = useState([]);
  const [tablehead, settablehead] = useState([]);
  const [tableBarData, setTableBarData] = useState([]);
  const [tableAlarmData, setTableAlarmData] = useState([]);
  const [tableDtcData, setTableDtcData] = useState([]);
  const [faultSelected, setfaultSelected] = useState("Occurrence");
  const [faultPercent, setFaultPercent] = useState([]);
  const [faultPercentAlram, setFaultPercentAlram] = useState([]);
  const [faultPercentDtc, setFaultPercentDtc] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let post_fix = "";

  if (IND == "RANGE") {
    post_fix = "Km";
  }

  function addECUPercentFault(arr) {
    const max_value = Math.max.apply(Math, arr.map(function (o) { return o.occ.value; }));
    let percentArr = [];
    arr.map((val, i) => {
      var percent = Math.ceil((val.occ.value / max_value) * 100);
      percentArr.push(isNaN(percent) ? 0 : percent);
    })
    return percentArr
  }
  console.log('databars');

  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU == element);
      index === -1 && dataArr.push({
        "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
      })
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    return dataA;
  }

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  }

  const appyData = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occ.value) })

      })
      setTableData((prestate) => responce);
      settablehead(thead)
    } else {
      setTableData((prestate) => []);
      settablehead([])
    }
  }

  const appyBarData = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const mainECU = [{ "key": "BCS", "occ": 0 }, { "key": "BMS", "occ": 0 }, { "key": "DCDC", "occ": 0 }, { "key": "MCU", "occ": 0 }, { "key": "OBC", "occ": 0 }, { "key": "VCU", "occ": 0 }];
    const res_result = data;
    let responce = [];

    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, occ: (obj.occ.value) })

    })

    const ecu = addECU(data, "occ")
    setFaultPercentAlram(addECUPercentFault(ecu));
    setTableAlarmData(ecu);
  }

  const appyDtcData = (data) => {
    const thead = { "head1": "Vin", "head2": "Count" };
    const res_result = data;
    let responce = [];
    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, occ: (obj.occ.value) })
    })

    const ecu = addECU(data, "occ")
    setFaultPercentDtc(addECUPercentFault(ecu));
    setTableDtcData(ecu);
  }

  const appyDataDuration = (data) => {
    const res_result = data;
    const thead = { "head1": "Vin", "head2": "Mins" };

    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occ.value) })
      })
      setTableData((prestate) => responce);
      settablehead(thead)
    } else {
      setTableData((prestate) => []);
    }
  }
  


  const filterChnaged = (event) => {
    setfaultSelected(event.target.value)
    let value = event.target.value
    if (value == "Duration") {
      fetchData({ url: API_URL_MAIN + "coral_Fault_analysis/Topvehicleswithfaultsduration", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataDuration)
   
    } else {
      fetchData({ url: API_URL_MAIN + "coral_Fault_analysis/Topvehicleswithfaults", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyData)
     
    }
  }

  // const responceData = (data) => {
  //   const ecu = addECU(data, "occ")
  //   setFaultPercent(addECUPercentFault(ecu));
  //   setTableBarData(ecu)
  // }
 const responceData = (data) => {
  // Filter out "Others" and transform the rest
  const transformedData = data
    .filter(item => item.key !== "Others") // 👈 Removes "Others"
    .map(item => ({
      key: { ECU: item.key },
      occ: { value: item.unique_vehicle_count.value }
    }));

  const ecu = addECU(transformedData, "occ");
  setFaultPercent(addECUPercentFault(ecu));
  setTableBarData(ecu);
}



  function generateBarGraph(wrapper) {

    // Set Up Values Array
    var values = [];

    // Get Values and save to Array
    $(wrapper + ' .bar').each(function (index, el) {
      values.push($(this).data('value'));
    });

    // Get Max Value From Array
    var max_value = Math.max.apply(Math, values);

    // Set width of bar to percent of max value
    $(wrapper + ' .bar').each(function (index, el) {
      var bar = $(this),
        value = bar.data('value'),
        percent = Math.ceil((value / max_value) * 100);

      // Set Width & Add Class
      // bar.width(percent + '%');
      bar.addClass('in');
    });
  }
// const staticFaultAnalysisData = [
//   { key: { ECU: "BCS" }, occ: { value: 0 } },
//   { key: { ECU: "BMS" }, occ: { value: 2 } },
//   { key: { ECU: "DCDC" }, occ: { value: 0 } },
//   { key: { ECU: "MCU" }, occ: { value: 2 } },
//   { key: { ECU: "OBC" }, occ: { value: 1 } },
//   { key: { ECU: "VCU" }, occ: { value: 3 } },
// ];
  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "coral_fault_analysis/Topvehicleswithfaults", body: { filterdata: gloablfilter, IND } }, appyData)
    fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/faultanalysisfleet', body: { filterdata: gloablfilter, IND } }, responceData);
    fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/alarmanalysis', body: { filterdata: gloablfilter, IND } }, appyBarData);
    fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/dtcanalysis', body: { filterdata: gloablfilter, IND } }, appyDtcData);
  }, [gloablfilter]);  // Fully reference jQuery after this point. 
//   useEffect(() => {
//   // Replacing API calls with static data handlers
//   // appyData(staticOccurrenceData);
//   responceData(staticFaultAnalysisData);
//   // appyBarData(staticAlarmAnalysisData);
//   // appyDtcData(staticDtcAnalysisData);
// }, []); 

  useEffect(() => {
    generateBarGraph('#dashboard-stats');
    generateBarGraph('#dashboard-statsUFA')
    generateBarGraph('#dashboard-statsDTC')
  }, [tableBarData, tableAlarmData, tableDtcData]);

  return (
    <div className="row">
      <div className="col-md-6 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne">
          <div className="row">
            <div className="col-md-12 col-sm-6 col-lg-7">
              <div className="titlebg">Vehicle with Fault</div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-5">
              <select className="form-select form-select-sm" aria-label="Default select example" onChange={filterChnaged} value={faultSelected}>
                <option value="Duration">Duration</option>
                <option value="Occurrence">Occurrence</option>
              </select>
            </div>
          </div>
          <div className="chartHGT">
            <WaterMark />
            <div className="table-responsive ">
              {(isLoading) ? <ChartLoader_Coral /> : <Table_Coral data={tableData} head={tablehead} singleVinSelected={singleVinSelected} post_fix={post_fix} />}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-sm-12 pr-0">
  <div className="v-title chartboxPageOne" style={{ height: "100%" }}>
    <div className="titlebg">Fault analysis</div>
    <div className="chartHGT" style={{ height: "100%" }}>
      <div className="boxHead">
        <div className="float-start">
          <p className="boxHeadText">ECU</p>
        </div>
        <div className="float-end">
          <p className="boxHeadText">Vehicle Count</p>
        </div>
      </div>
      <div className="chart-wrap" style={{ height: "calc(100% - 40px)" }}>
        <WaterMark />
        <div style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "4px" }}>
          <div id="dashboard-stats" className="chart bars-horizontal brand-primary">
            {(tableBarData.length === 0) ? (
              <NoTableData_Coral />
            ) : (
              tableBarData.map((x, i) => (
                <div
                  className="row align-items-center"
                  key={x.key}
                  style={{ marginBottom: "18px" }}
                >
                  <span className="label" style={{ width: "60px" }}>{x.key.ECU}</span>
                  <div className="bar-wrap" style={{ flex: 1, marginLeft: "10px", marginRight: "10px" }}>
                    <div
                      className="bar"
                      data-value={x.occ.value}
                      style={{ width: faultPercent[i] + "%", height: "14px" }}
                    />
                  </div>
                  <span className="number" style={{ minWidth: "30px" }}>{x.occ.value}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    
    </div>
  )
}
export default FaultFirstPageDataBars_Coral;